import React, { FC, memo, RefObject, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { IURLSearchParams } from "@/core/url";
import { IJobRequest, IPageableJobRequest } from "@/data/job-requests";
import { IPageableFetcherRenderProps } from "@/hooks/http";
import { InfoboxSection } from "@/views/components/Page";

import { JobRequestsListRenderer } from "./components";

interface Props extends IPageableFetcherRenderProps<IJobRequest, IPageableJobRequest> {
  sortConfig: IURLSearchParams["sortConfig"];
  lastJobOfferRef: RefObject<HTMLDivElement>;
}

export const PublicJobRequestsList: FC<Props> = memo(props => {
  const { t } = useTranslation("public");

  const renderEmpty = useCallback(() => {
    return (
      <InfoboxSection
        heading={t("LANDING_PAGE.JOB_REQUEST.LIST.NO_MATCHING_JOBS")}
        description={t("LANDING_PAGE.JOB_REQUEST.LIST.NO_MATCHING_JOBS_TEXT")}
      />
    );
  }, [t]);

  return <JobRequestsListRenderer {...props} recordVariant="short" renderEmpty={renderEmpty} trackingSource="Search" />;
});
